import React from 'react'
import Section1 from '../ComponentsPage/CompanyOverview/Section1'
import Section2 from '../ComponentsPage/CompanyOverview/Section2'
import Section3 from '../ComponentsPage/CompanyOverview/Section3'
import About from '../ComponentsPage/Banner/About'
const CompanyOverview = () => {
  return (
    <>
      <About/>
      <Section1 />
      <Section2 />
      <Section3 />
    </>
  )
}

export default CompanyOverview
